import { memo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";

const BTN_LINK_STYLE = { textDecoration: "none" as const };

interface MuslimInvestFormHeaderBackProps {
  /** One step back within the wizard; omit to return to Register Profile cards (/investing). */
  onBack?: () => void;
}

const MuslimInvestFormHeaderBack = memo(function MuslimInvestFormHeaderBack({
  onBack,
}: MuslimInvestFormHeaderBackProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const label = t("muslimInvest.back");

  const handleClick = useCallback(() => {
    if (onBack) {
      onBack();
      return;
    }
    navigate("/investing");
  }, [onBack, navigate]);

  return (
    <button
      type="button"
      className="btn btn-link text-white me-2 d-inline-flex align-items-center gap-2 flex-shrink-0 p-0"
      onClick={handleClick}
      style={BTN_LINK_STYLE}
      aria-label={label}
    >
      <FontAwesomeIcon icon={faArrowLeft} />
      <span className="fw-semibold">{label}</span>
    </button>
  );
});

MuslimInvestFormHeaderBack.displayName = "MuslimInvestFormHeaderBack";

export default MuslimInvestFormHeaderBack;
